import React from 'react'
import PropTypes from 'prop-types'

const LocalizedString = (props) => <span>{props.localize(props.resourceKey, props.args || [])}</span>

LocalizedString.propTypes = {
  args: PropTypes.array,
  localize: PropTypes.func.isRequired,
  resourceKey: PropTypes.string.isRequired
}

export default LocalizedString



// WEBPACK FOOTER //
// ./src/components/LocalizedString/LocalizedString.js